import {
  ExtranetModal,
  ExtranetModalBody,
  ExtranetModalHeader,
  useBreakpoint,
} from '@pharmac-extranet/shared'
import { PharmacButton } from '@pharmac/ui'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string | React.ReactNode
  content: string | React.ReactNode
  closeButtonText?: string
  submitButtonText?: string
  continueButtonText?: string
  onClose?: () => void
  onSubmit?: () => void
  onContinue?: () => void
  showOnProp?: boolean
  preventClose?: boolean
  footerInfo?: React.ReactNode
  disableOnSubmit?: boolean
  wideModal?: boolean
}

export const ConfirmationModal = ({
  showOnProp,
  title,
  closeButtonText,
  submitButtonText,
  continueButtonText,
  content,
  preventClose,
  footerInfo,
  disableOnSubmit,
  wideModal,
  onClose,
  onSubmit,
  onContinue,
}: Props) => {
  const { t } = useTranslation('common')
  const { minDesktop } = useBreakpoint()

  const modalButtons = [
    !!onContinue && (
      <PharmacButton onClick={onContinue}>{continueButtonText ?? t('continue')}</PharmacButton>
    ),
    !!onClose && (
      <PharmacButton
        onClick={onClose}
        marginSmallRight
        marginMediumTop={!minDesktop}
        variant="secondary"
        fullWidth={!minDesktop}
      >
        {closeButtonText ?? t('no')}
      </PharmacButton>
    ),
    !!onSubmit && (
      <PharmacButton
        onClick={onSubmit}
        disabled={disableOnSubmit}
        marginMediumTop={!minDesktop}
        fullWidth={!minDesktop}
      >
        {submitButtonText ?? t('yes')}
      </PharmacButton>
    ),
  ].filter(Boolean)

  return (
    <ExtranetModal
      preventClose={preventClose}
      buttons={modalButtons as JSX.Element[]}
      footerContent={footerInfo}
      showOnProp={showOnProp}
      closeOnOutsideClick={true}
      closeModal={onClose}
      modalBackground={'rgba(0, 0, 0, 0.13)'}
      wideModal={wideModal}
    >
      <ExtranetModalHeader>{title}</ExtranetModalHeader>
      <ExtranetModalBody>{content}</ExtranetModalBody>
    </ExtranetModal>
  )
}
